<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0003 18.0413C9.74199 18.0413 9.49199 18.008 9.28366 17.933C6.10033 16.8413 1.04199 12.9663 1.04199 7.24134C1.04199 4.32467 3.40033 1.95801 6.30033 1.95801C7.70866 1.95801 9.02533 2.50801 10.0003 3.49134C10.9753 2.50801 12.292 1.95801 13.7003 1.95801C16.6003 1.95801 18.9587 4.33301 18.9587 7.24134C18.9587 12.9747 13.9003 16.8413 10.717 17.933C10.5087 18.008 10.2587 18.0413 10.0003 18.0413ZM6.30033 3.20801C4.09199 3.20801 2.29199 5.01634 2.29199 7.24134C2.29199 12.933 7.76699 16.0997 9.69199 16.758C9.84199 16.808 10.167 16.808 10.317 16.758C12.2337 16.0997 17.717 12.9413 17.717 7.24134C17.717 5.01634 15.917 3.20801 13.7087 3.20801C12.442 3.20801 11.267 3.79967 10.5087 4.82467C10.2753 5.14134 9.74199 5.14134 9.50866 4.82467C8.73366 3.79134 7.56699 3.20801 6.30033 3.20801Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
